import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";
import { topics } from "@/mocks/topics";
import SectionHeading from "@/components/feature/SectionHeading";
import Reveal from "@/components/feature/Reveal";

export default function CategoryGrid() {
  const list = categories.filter((item) => item.key !== "全部");

  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20 lg:px-12">
      <div className="mx-auto max-w-6xl">
        <SectionHeading
          eyebrow="按主题逛瓜田"
          title="挑一个你关心的领域"
          desc="不同领域的事件关注点并不一样。选一个分类，直接进入对应的复盘合集。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item, index) => {
            const count = topics.filter((topic) => topic.category === item.key).length;
            const isAccent = index % 3 === 1;

            return (
              <Reveal key={item.key} delay={index * 60}>
                <Link
                  to={`/topics?cat=${encodeURIComponent(item.key)}`}
                  className="group flex h-full cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
                >
                  <span
                    className={`flex h-11 w-11 items-center justify-center rounded-md text-xl ${
                      isAccent
                        ? "bg-accent-100 text-accent-700"
                        : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    <i className={item.icon} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                    {item.label}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                  <span className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                    <span>{count} 篇复盘</span>
                    <span className="flex items-center gap-1 font-medium text-primary-600 transition-colors group-hover:text-primary-700">
                      进入分类
                      <span className="flex h-4 w-4 items-center justify-center">
                        <i className="ri-arrow-right-line" aria-hidden="true"></i>
                      </span>
                    </span>
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}